export interface VBCAboutProps {
  description: string | null;
}

/**
 * About section — vendor description. Server Component.
 */
export function VBCAbout({ description }: VBCAboutProps) {
  if (!description) return null;

  return (
    <section
      className="mb-10 rounded-xl border p-6"
      style={{
        borderColor: 'var(--brand-card-border)',
        boxShadow: 'var(--shadow-resting)',
        backgroundColor: 'var(--brand-card-bg)',
      }}
    >
      <h2
        className="overline mb-4"
        style={{ color: 'var(--brand-primary, #014F8A)' }}
      >
        About
      </h2>
      <p
        className="whitespace-pre-line leading-relaxed"
        style={{
          color: 'var(--brand-text-muted)',
          fontSize: '14px',
          lineHeight: 1.7,
          letterSpacing: '0.01em',
        }}
      >
        {description}
      </p>
    </section>
  );
}
